import { CommonModule } from '@angular/common';
import {
    Component,
    DestroyRef,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    effect,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { Translation, TranslocoService } from '@ngneat/transloco';
import { AlertService } from 'app/core/alert/alert.service';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import {
    GridViewsModule,
    TableColumnDef,
} from '../../../../../../../projects/grid-views/src/public-api';
import { AiqDialogService } from './aiq-dialog.service';
import { AiqDialogData } from './aiq.model';

@Component({
    selector: 'aiq-dialog',
    imports: [CommonModule, GridViewsModule],
    templateUrl: './aiq-dialog.component.html',
    styleUrl: './aiq-dialog.component.scss',
})
export class AiqDialogComponent extends DialogBuilderComponent<any> implements OnInit {
    questions: WritableSignal<Array<AiqDialogData>> = signal([]);
    selectedQuestion: WritableSignal<AiqDialogData> = signal(null);

    // Table
    displayedColumns: Array<TableColumnDef> = [];

    dataSource: Signal<MatTableDataSource<any>> = computed(
        () => new MatTableDataSource(this.questions())
    );

    private _translocoContent: WritableSignal<Translation> = signal({});

    constructor(
        private service: AiqDialogService,
        private alertService: AlertService,
        private translocoService: TranslocoService,
        private _destroyRef: DestroyRef
    ) {
        super();

        this.translocoService
            .selectTranslation()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(content => {
                this._translocoContent.set(content);
                this.displayedColumns = [
                    {
                        columnKey: 'question',
                        columnName: this._translocoContent()['aiq.question'],
                        enableSorting: true,
                    },
                ];
            });

        effect(() => {
            const code = this.executeActionSignal();
            if (code === 'select') {
                if (this.selectedQuestion()) {
                    this.closeDialog(this.selectedQuestion().question);
                } else {
                    this.alertService.errorAlert('errors', 'noQuestionSelected');
                }
                this.executeActionSignal.set(null);
            }
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.questions.set(this.service.getQuestions());
    }

    rowSelectionChange($event: Array<any>) {
        this.selectedQuestion.set($event[0]);
    }
}
